import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here
import Config from "../Config.jsx";

import Localization from "../Localization.jsx"

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from '@material-ui/core';

import ReactHtmlParser from 'react-html-parser';

class AgreementDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
    };
    autoBind(this);
  }

  handleClose() {
    this.props.parent.setState({agreementDialogOpen: false});
    this.props.parent.state.agreementDialogOpen = false;
  }

  btnCancelClicked() {
    this.handleClose();
  }

  btnOKClicked() {
    let requestObj = {
      user_id: this.props.parent.state.loginResult.id,
      agreement_version: this.props.parent.state.latestAgreementVersion,
    }
    this.props.root.refs.API.request("user_accept_agreement", requestObj);
    this.props.parent.agreementAccepted();
  }

  render() {
    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={'md'}
          open={this.props.parent.state.agreementDialogOpen}
          onClose={this.handleClose}
        >
          <DialogContent>
            {ReactHtmlParser(this.props.parent.state.agreemenText)}
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <Button onClick={this.btnCancelClicked}>{Localization.strings.DECLINE}</Button>
            <Button
              onClick={this.btnOKClicked}
              color="primary"
              variant="contained"
            >
              {Localization.strings.ACCEPT}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default AgreementDialog;
